import { initFileInputs } from "./file-inputs.js";
import { initFormSubmitLock } from "./form-submit-lock.js";
import { initFormChoiceClickableItems } from "./form-choice-clickable-items.js";
import { initMenu } from "./menu.js";
import { initAllAnimations } from "./animations.js";
import { initPageTransitions } from "./page-transition.js";
import { initHashScroll } from "./scroll-to-hash.js";
import { initFuniculaireScroll } from "./funiculaire-scroll.js";

let pageTransitionsInitialized = false;

//Prevent page transitions to not complete if an error occurs
try {
  initMenu();
  initFileInputs();
  initFormSubmitLock();
  initFormChoiceClickableItems();
  initPageTransitions();
  pageTransitionsInitialized = true;
  initHashScroll();
  initAllAnimations();
  // initAllAnimations() clears *all* ScrollTriggers ~100ms after load (see
  // animationUtils.clearScrollTriggers in animations.js) as part of its own
  // setup, which would kill these triggers if created any earlier.
  setTimeout(initFuniculaireScroll, 150);
} catch (error) {
  console.error("[theme-interne] init failed", error);

  if (!pageTransitionsInitialized) {
    initPageTransitions();
  }
}
